<script setup lang="ts"></script>

<template>
  <div
    class="bg-main-50 bordershadow-lg-main relative flex max-w-[24rem] rotate-2 items-center overflow-hidden rounded-xl p-2"
  >
    <Gradient
      id="business-card"
      class="bordershadow-main-light z-0 h-full w-full rounded aspect-[16/10]"
      :gradient-options="{ amplitude: 10, density: [0.1, 0.01] }"
    />
    <div class="border-main-400 bg-main-50 absolute right-4 h-12 w-2 rounded-full border shadow-inner"></div>

    <div class="absolute inset-0 flex h-full w-full flex-col justify-end p-6">
      <NuxtImg
        src="/local/ceo.jpg"
        width="128"
        height="128"
        format="webp"
        fit="cover"
        class="border-main-400 absolute -right-1 -top-1 h-20 w-20 rounded-full rounded-tr-none border object-cover"
      />

      <Heading size="medium" class="mb-2 w-full">
        {{ $t('contact.business_card.title') }}
      </Heading>

      <Paragraph size="normal" class="w-3/4">
        {{ $t('contact.business_card.description') }}
      </Paragraph>
    </div>
  </div>
</template>
